import { render, staticRenderFns } from "./Procesando.vue?vue&type=template&id=146481b4&"
import script from "./Procesando.vue?vue&type=script&lang=js&"
export * from "./Procesando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports